import React from 'react';
import Layout from '../components/layout';
import SEO from '@accrosoft-ltd/accropress-websites-components/dist/esm/seo';
import WeducLogin from '@accrosoft-ltd/accropress-websites-components/dist/esm/weducLogin';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LoginPageTemplate = function LoginPageTemplate(_ref) {
  var pluginOptions = _ref.pageContext.pluginOptions,
      props = _ref.props;
  var config = pluginOptions;
  return /*#__PURE__*/_jsxs(Layout, {
    children: [/*#__PURE__*/_jsx(SEO, {
      navResultData: {},
      contentDataData: {},
      integratorData: {},
      contentMetaData: {
        seoTitle: 'Login with Weduc',
        metaDescription: 'Login in with your Weduc account from our website.'
      },
      gatsbyConfigSiteMetaData: {},
      gatsbyConfigPluginsAPOptions: {}
    }), /*#__PURE__*/_jsx("div", {
      className: "login-page-wrapper",
      children: /*#__PURE__*/_jsx("div", {
        className: "container",
        children: /*#__PURE__*/_jsx(WeducLogin, {
          entity: config.loginPageEntityID
        })
      })
    })]
  });
};

export default LoginPageTemplate;